
import { getEnumKeys, getEnumValueFromKey } from "@/utils/enum";
import { ExcelMapperColSetting, ExcelMapperColSettingType } from "@/utils/excel-mapper/excel-mapper-col-setting";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";
import AppValueAutocomplete from "./ExcelMapperSettingsEditColumnValueAutocomplete.vue";
import AppErrorMessageBox from "@/components/common/ErrorMessageBox.vue";
import "codemirror/mode/javascript/javascript";

export default Vue.extend({
	data(){
		return {
			scriptErrorMessage: ""
		};
	},
	props: {
		value: {
			type: Object as ()=>ExcelMapperColSetting,
			required: true
		},
		label: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
		knownHeaders: {
			type: Array as ()=>string[],
			required: true
		}
	},
	computed: {
		settingsTypes():ISelectItem<ExcelMapperColSettingType>[] {
			return getEnumKeys(ExcelMapperColSettingType).map(e=>{
				return {
					text: this.$ct("col-setting-type." + e),
					value: getEnumValueFromKey(ExcelMapperColSettingType, e)
				};
			});
		},
		codeMirrorOptions():any{
			return {
				mode: "text/javascript",
			};
		},
	},
	methods: {
		validateScript(){
			if (this.value.Type != ExcelMapperColSettingType.CODE) {
				this.scriptErrorMessage = "";
				return;
			}
			this.scriptErrorMessage = ExcelMapperColSetting.validateScript(this.value.Value);
		},
		onScriptInput(value:string){
			this.value.Value = value;
			this.validateScript();
		}
	},
	mounted(){
		if (this.value.Type == ExcelMapperColSettingType.CODE) {
			this.validateScript();
		}
	},
	components: {
		AppValueAutocomplete,
		AppErrorMessageBox
	},
	i18nEx: {
		componentPrefix: "components.excel-mapper"
	}
});
